import { IBillRequest } from "@/models/billRequest/billRequest.types"
import { BillRequestParser } from "@/models/billRequest/billRequest.parser"
import { QueryResult } from "@/api/utils/types"
import { useQuery } from "@/api/utils/useQuery"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { BillRequest } from "@/api/backofficeRest/generated/model"

export interface IBillRequestService {
  getForAccount(billingAccountId: number | null): QueryResult<IBillRequest[]>
}

class BillRequestServiceClass implements IBillRequestService {
  getForAccount(billingAccountId: number | null): QueryResult<IBillRequest[]> {
    return useQuery({
      ...BackofficeRestQueries.billing.billRequests(billingAccountId ?? 0),
      placeholderData: [],
      useRawResponse: true,
      enabled: !!billingAccountId,
      parserFn: (rawData: BillRequest[]) =>
        (rawData ?? []).map((rawBillRequest) =>
          BillRequestParser.toDomain(rawBillRequest),
        ),
    })
  }
}

export const BillRequestService = new BillRequestServiceClass()
